import type { ComponentProps, ReactNode } from 'react'
import type { To } from 'react-router-dom'
import { NavLink } from 'react-router-dom'

type NavLinkProps = ComponentProps<typeof NavLink>
type ButtonProps = ComponentProps<'button'>

type AppSidebarItemProps = {
  to?: To
  children: ReactNode
  onClick?: () => void
} & Omit<NavLinkProps, 'to' | 'children' | 'onClick'> &
  Omit<ButtonProps, 'children' | 'onClick'>

export function AppSidebarNavItem({ to, children, onClick, ...rest }: AppSidebarItemProps) {
  if (to !== undefined && to !== null) {
    return (
      <NavLink to={to} {...rest}>
        {children}
      </NavLink>
    )
  }

  return (
    <button type="button" onClick={onClick} className="w-full text-left" {...rest}>
      {children}
    </button>
  )
}
